// Module
var code = `<div [attr.tid]="tid"></div>
<ng-container *ngIf="state.loadedPropertyId">
    <div *ngIf="state.lineItems && state.lineItems.length > 0" class="HOA-propertyblock-flextable" [attr.tid]="tid + '-items'">
        <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--60 HOA-propertyblock-flextable--truncate">
            <div class="HOA-propertyblock-flextable__cell-label HOA-propertyblock-flextable--truncate">
                Balance Summary
            </div>
        </div>
        <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--40 HOA-propertyblock-flextable--truncate">
            <div class="HOA-propertyblock-flextable__cell-label HOA-propertyblock-flextable--truncate u-margin-right-align">
                Amount
            </div>
        </div>
        <div *ngFor="let item of state.lineItems">
            <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--60 HOA-propertyblock-flextable--truncate">
                <div class="HOA-propertyblock-flextable__cell-value">
                    {{item.display}}
                </div>
            </div>,
            <div class="HOA-propertyblock-flextable__cell HOA-propertyblock-flextable__cell--list HOA-propertyblock-flextable__cell--40 HOA-propertyblock-flextable--truncate">
                <div class="HOA-propertyblock-flextable__cell-value u-margin-right-align">
                    {{item.amount | currency:"USD":"symbol"}}
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!state.loadedPropertyId">
    <span class="HOA-property-line-item-loader" [attr.tid]="tid + '-loader'" [style.opacity]=1 ></span>
</ng-container>`;
// Exports
module.exports = code;